'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Image from 'next/image';

export function Preloader() {
  const pathname = usePathname();
  const [isLoading, setIsLoading] = useState(true);
  const [isHiding, setIsHiding] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Reset state on path change
    setIsLoading(true);
    setIsHiding(false);
    setProgress(0);

    // Animate progress smoothly
    const progressTimer = setTimeout(() => {
       setProgress(100);
    }, 100);

    // Start hiding animation after 800ms
    const hideTimer = setTimeout(() => {
      setIsHiding(true);
    }, 800);

    // Completely remove after animation completes (800ms + 500ms fade)
    const removeTimer = setTimeout(() => {
      setIsLoading(false);
    }, 1300);
    
    return () => {
      clearTimeout(progressTimer);
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };
  }, [pathname]);

  if (!isLoading) return null;

  return (
    <div
      className={`fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-background transition-opacity duration-500 ease-in-out ${
        isHiding ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center justify-center relative transform transition-transform duration-500 animate-in zoom-in-90 fade-in">
         <div className="relative w-40 h-40 mb-8 border-4 border-primary/20 rounded-full p-2 bg-card shadow-2xl">
            <Image
              src="https://i.postimg.cc/sxSMDjTL/logo.jpg"
              alt="Upbeat Brain Game Loading"
              fill
              className="object-contain rounded-full animate-pulse shadow-inner"
              unoptimized
            />
         </div>
         
         {/* Custom Progress Bar */}
         <div className="h-2 w-48 bg-secondary rounded-full overflow-hidden relative shadow-inner">
            <div 
               className="absolute top-0 left-0 h-full bg-primary transition-all rounded-full ease-out" 
               style={{ width: `${progress}%`, transitionDuration: '700ms' }}
            />
         </div>
         
         <div className="mt-4 text-sm font-semibold tracking-widest text-muted-foreground uppercase animate-pulse">
            Loading...
         </div>
      </div>
    </div>
  );
}
